<template>

    <div class="question__body" :class="{ '-locked': disabled }">
        <question-title :title="title" :sub-title="subTitle" :hashelp="hashelp" :uuid="uuid" :question-index="questionIndex"></question-title>

        <div class="choices radio-button-group" role="radiogroup" :aria-labelledby="'q_' + uuid">
            <div class="radio" v-for="(choice, index) of choices" :key="index">
                <radio-button-choice
                    :question-index="questionIndex"
                    :choice="choice"
                    :uukey="uukey"
                    :triggers="triggers"
                    :answer="answer.answer"
                    :disabled="disabled"
                    :read-only="readOnly"
                ></radio-button-choice>
            </div>
        </div>
        <question-tip :questionTip="questionTip"></question-tip>
    </div>

</template>

<script>
import { questionMixin } from './mixins/question-mixin';

export default {
    name: 'radio-button-group',

    mixins:[
        questionMixin,
    ],

    methods: {

        changeValue(value)
        {
            this.dispatchChangeAnswer([this.uukey, value]);
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/radio-button-group.vue